import { VendorLayoutV2 } from "~/components/common/layouts/VendorLayoutV2";
import Styles from "./Page.module.scss";

type Props = {
	message?: string;
};

export function Page({ message }: Props) {
	return (
		<VendorLayoutV2>
			<div className={Styles.ErrorContainer}>
				<h1 className={Styles.ErrorTitle}>権限がありません</h1>
				<p className={Styles.ErrorMessage}>{message || ""}</p>
			</div>
		</VendorLayoutV2>
	);
}
